import { render, staticRenderFns } from "./StudentPreRegistrationCreate.vue?vue&type=template&id=e1b22970&scoped=true"
import script from "./StudentPreRegistrationCreate.vue?vue&type=script&lang=js"
export * from "./StudentPreRegistrationCreate.vue?vue&type=script&lang=js"
import style0 from "./StudentPreRegistrationCreate.vue?vue&type=style&index=0&id=e1b22970&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b22970",
  null
  
)

export default component.exports